export const types = {
  DRAFT: 'DRAFT',
  AWAITING_REVIEW: 'AWAITING_REVIEW',
  APPROVED: 'APPROVED',
  DISAPPROVED: 'DISAPPROVED',
};